import type React from 'react'
import { Badge } from '@/components/ui/badge'

interface WorkbenchShellProps {
  stationName: string
  chapterLabel: string
  versionLabel: string
  configPanel: React.ReactNode
  previewPanel: React.ReactNode
  versionPanel: React.ReactNode
}

export function WorkbenchShell({
  stationName,
  chapterLabel,
  versionLabel,
  configPanel,
  previewPanel,
  versionPanel,
}: WorkbenchShellProps) {
  return (
    <div className="flex min-h-[calc(100vh-3.5rem)] flex-col bg-background">
      <header className="flex min-h-14 flex-wrap items-center justify-between gap-3 border-b px-4 py-3">
        <div className="min-w-0">
          <h1 className="truncate text-lg font-semibold tracking-normal">{stationName}</h1>
          <p className="truncate text-sm text-muted-foreground">{chapterLabel}</p>
        </div>
        <Badge variant="outline" className="rounded-md">
          {versionLabel}
        </Badge>
      </header>
      <main className="grid min-h-0 flex-1 grid-cols-1 lg:grid-cols-[minmax(18rem,24rem)_minmax(0,1fr)_minmax(16rem,20rem)]">
        <aside className="min-h-0 border-b p-4 lg:border-r lg:border-b-0">{configPanel}</aside>
        <section className="min-h-[24rem] border-b p-4 lg:border-r lg:border-b-0">{previewPanel}</section>
        <aside className="min-h-0 p-4">{versionPanel}</aside>
      </main>
    </div>
  )
}
